import { USER_ROLES } from './utils/users'

const TAG_COLORS = {
  white: '#FFFFFF',
  primary: '#436AFF',
  red: '#FF4141',
  orange: '#FF9913',
  darkGray: '#979797',
  lightGray: '#D8D8D8',
  gray: '#A6B8D1',
  blue: '#41D2FF',
  pink: '#FD73FF',
  purple: '#7A69BC',
  black: '#191919',
  update: '#7E68C2',
  lightBlue: '#939fc6',
  darkBlue: '#0000EE',
  beta: '#EBA724',
  upload: '#EBFF00',
  lightGreen: '#189925',
  pendingDelivery: '#CCD5AE',
  darkGreen: '#59E6C8',
  lavender: '#D94DCC',
  lightOrange: '#DAC0A3',
  bordeaux: '#A0153E',
  pastelYellow: '#F4DC85',
  lightBlueGray: '#BDCDD6',
  gold: '#BB9C2E',
  brown: '#C4A6A6',
  beige: '#C6A093',
  aquaMarine: '#73C9AD',
  teak: '#B18D64',
  paleBlueViolet: '#B2A4FF',
  gunMetal: '#272A36',
  lightBrown: '#E7CFB8', // customerReview color
  lightOceanBlue: '#007599',
  appleGreen: '#43D439',
  cloudyBlue: '#AABFD4',
  trialConverted: '#B0D9B1',
  retailer: '#FAEDCD',
  supplier: '#CFD2DB',
}

const TAG_COLORS_LIGHT = {
  yellow: '#FFD700',
  green: '#008000',
  ...TAG_COLORS,
}

const TAG_COLORS_DARK = {
  yellow: '#FFE632',
  green: '#41FF8A',
  ...TAG_COLORS,
}

export const themeDark = {
  colors: {
    primary: {
      main: '#436AFF',
      light: '#587BFF',
      dark: '#2750F0',
      contrast: '#FFFFFF',
    },
    secondary: {
      dark: '#191919',
      main: '#191919',
      light: '#323232',
      contrast: '#FFFFFF',
    },
    tertiary: {
      main: '#9AA7FF',
      light: '#BBC4FF',
      dark: '#8694FF',
      contrast: '#252525',
    },
    green: {
      main: '#59E6C8',
      light: '#59E6C8',
      dark: '#59E6C8',
      contrast: '#252525',
    },
    lightRed: {
      main: '#FF958C',
      light: '#FF958C',
      dark: '#FF958C',
      contrast: '#252525',
    },
    purple: {
      main: '#7A69BC',
      light: '#E8E2FF',
      dark: '#6859A0',
      contrast: '#252525',
      darker: '#6859A0',
    },
    lightGray: {
      main: '#F2F2F2',
      light: '#F2F2F2',
      dark: '#F2F2F2',
      contrast: '#191919',
    },
    gray: {
      darker: '#191919',
      dark: '#191919',
      main: '#252525',
      second: '#2C2C2C',
      light: '#323232',
      lighter: '#9D9D9D',
      contrast: '#FFFFFF',
    },
    text: {
      main: '#FFFFFF',
      gray: '#9D9D9D',
      contrast: '#191919',
    },
    white: {
      main: '#FFFFFF',
      light: '#FFFFFF',
      dark: '#FFFFFF',
      contrast: '#191919',
    },
    darkBlue: {
      main: '#272A36',
      light: '#373944',
      dark: '#171B32',
      contrast: '#FFF',
    },
    darkPurple: {
      main: '#1E0E32',
      light: '#1E0E32',
      dark: '#120127',
      contrast: '#FFFFFF',
    },
    transparent: {
      main: 'transparent',
      light: 'transparent',
      dark: 'transparent',
      contrast: '#FFFFFF',
    },
    background: {
      dark: '#191919',
      main: '#252525',
      second: '#2C2C2C',
      light: '#323232',
      lighter: '#9D9D9D',
      contrast: '#FFFFFF',
    },
    tag: TAG_COLORS_DARK,
    alert: {
      main: '#FF4141',
      light: '#FF6464',
      dark: '#D0021B',
      contrast: '#FFFFFF',
    },
    warning: {
      main: '#FF9913',
      light: '#FF9913',
      dark: '#FF9913',
      contrast: '#FFFFFF',
    },
    order: {
      main: '#D329A0',
      light: '#FF5ECF',
      dark: '#A11A79',
      contrast: '#FFFFFF',
    },
    update: {
      main: '#7E68C2',
      light: '#B39FF1',
      dark: '#5A4A8A',
      contrast: '#FFFFFF',
    },
    maintenance: {
      main: '#F3DB4C',
      light: '#FFEF90',
      dark: '#DEBE00',
      contrast: '#FFFFFF',
    },
    approve: {
      main: '#00B000',
      light: '#00B000',
      dark: '#00B000',
      contrast: '#FFFFFF',
    },
    reject: {
      main: '#FF233E',
      light: '#FF233E',
      dark: '#FF233E',
      contrast: '#FFFFFF',
    },
    review: {
      main: '#FFD700',
      light: '#FFD700',
      dark: '#FFD700',
      contrast: '#191919',
    },
    customerReview: {
      main: '#E7CFB8',
      light: '#E7CFB8',
      dark: '#E7CFB8',
      contrast: '#191919',
    },

    messageDialog: {
      main: '#323946',
      light: '#384054',
      dark: '#1A212E',
      contrast: '#FFFFFF',
    },
    dashboard: {
      purple: '#8452ED',
      green: '#67DE92',
      white: '#FFFFFF',
    },
    milestone: {
      brief: '#F9D6D2',
      modeling: '#ACE9F7',
      studioReview: '#9DC3D9',
      customerReview: '#E7CFB8',
      finalisation: '#DAECC7',
      glbCreation: '#CFD2DB',
      updateProductThumbnail: '#DDC5D6',
      uploadSTFiles: '#B2A4FF',
      editST: '#FFB4B4',
      renderLDPlain: '#FFDEB4',
      renderLDPlainLayers: '#6096B4',
      renderLPLayers: '#BDCDD6',
      QASTInfinite: '#ECA869',
      setSTTesting: '#B08BBB',
      exitTestingFlow: '#73A9AD',
      replaceDefaultProducts: '#CCD5AE',
      activateST: '#FAEDCD',
      importVideo: '#FF958C',
      importSilo: '#E8C7DE',
      createACloseUp: '#FFC700',
      pdpPackageReviewByCustomer: '#EA7B72',
      createProductFocusWithAI: '#6A994E',
    },
    deadlineDistribution: {
      modeler: '#64CCC5',
      qcCheck: '#6096B4',
      rework: '#FF958C',
      studioReview: '#E8C7DE',
    },
    role: {
      [USER_ROLES.ACCOUNT_MANAGER]: '#8045A6',
      [USER_ROLES.ADMIN]: '#8564B8',
      [USER_ROLES.API_STANDARD_USER]: '#3F3957',
      [USER_ROLES.CLUSTER_MANAGER_MODELING]: '#2F7A90',
      [USER_ROLES.DISPLAY]: '#2C8A78',
      [USER_ROLES.ORGANIZATIONS_ADMINISTRATOR]: '#88C336',
      [USER_ROLES.OWNER]: '#D4AE4A',
      [USER_ROLES.PRODUCTION_MANAGER]: '#DF5E00',
      [USER_ROLES.PROJECT_MANAGER]: '#C0563C',
      [USER_ROLES.SUPERADMIN]: '#BD5261',
      [USER_ROLES.SUPERUSER]: '#D00F6D',
      [USER_ROLES.TESTER]: '#F969C5',
    },
    certificateType: {
      '3DModeler': '#35E15C',
      '3DModelerChecker': '#01DB8D',
      clusterManager: '#02D5E1',
      imageEditor: '#B08BBB',
      default: '#015D8F',
    },
    batch: {
      main: '#D329A0',
      light: '#FF5ECF',
      dark: '#A11A79',
      contrast: '#FFFFFF',
    },
    vcp: {
      trayCompletion: '#FF958C',
      trayOrdering: '#FFD700',
      technicalSpecs: '#DDC5D6',
      extraVisualsPenalty: '#FF4141',
      complianceScoreTier1: '#FF1B0F',
      complianceScoreTier2: '#FF6F0F',
      complianceScoreTier3: '#F2CC23',
      complianceScoreTier4: '#C1E338',
      complianceScoreTier5: '#5BCA27',
      complianceScoreTier6: '#008000',
      pivotDataProprietary: '#D24BE6',
      pivotDataProprietaryBackground: '#D24BE61A',
    },
  },
  font: {
    size: {
      xxs: 7,
      xs: 10,
      s: 12,
      default: 14,
      m: 18,
      l: 22,
      xl: 26,
      xxl: 32,
      xxxl: 40,
    },
    weight: {
      light: '200',
      regular: '400',
      mid: '500',
      bold: '600',
      bolder: '700',
    },
    family: {
      default: 'Poppins, Source Sans Pro, Helvetica, sans-serif',
    },
  },
  modeHighlight: {
    colors: {
      primary: {
        main: '#436AFF',
        light: '#587BFF',
        dark: '#2750F0',
        contrast: '#FFFFFF',
      },
      secondary: {
        main: '#EDEDED',
        light: '#F9F7F7',
        dark: '#EDEDED',
        contrast: '#191919',
      },
      tertiary: {
        main: '#9AA7FF',
        light: '#BBC4FF',
        dark: '#8694FF',
        contrast: '#252525',
      },
      green: {
        main: '#59E6C8',
        light: '#59E6C8',
        dark: '#59E6C8',
        contrast: '#252525',
      },
      lightRed: {
        main: '#FF958C',
        light: '#FF958C',
        dark: '#FF958C',
        contrast: '#252525',
      },
      purple: {
        main: '#7A69BC',
        light: '#E8E2FF',
        dark: '#6859A0',
        contrast: '#252525',
      },
      lightGray: {
        main: '#F2F2F2',
        light: '#F2F2F2',
        dark: '#F2F2F2',
        contrast: '#191919',
      },
      gray: {
        main: '#FFFFFF',
        lighter: '#D2D2D2',
        light: '#F9F7F7',
        second: '#FCFBFB',
        dark: '#EDEDED',
        darker: '#EDEDED',
        contrast: '#191919',
      },
      text: {
        main: '#191919',
        light: '#5C5C5C',
        dark: '#0E0E0E',
        gray: '#9D9D9D',
        contrast: '#FFFFFF',
      },
      white: {
        main: '#FFFFFF',
        light: '#FFFFFF',
        dark: '#FFFFFF',
        contrast: '#191919',
      },
      transparent: {
        main: 'transparent',
        light: 'transparent',
        dark: 'transparent',
        contrast: '#FFFFFF',
      },
      background: {
        main: '#FFFFFF',
        lighter: '#D2D2D2',
        light: '#F9F7F7',
        second: '#FCFBFB',
        dark: '#EDEDED',
        contrast: '#191919',
      },
      tag: TAG_COLORS_DARK,
      alert: {
        main: '#FF4141',
        light: '#FF6464',
        dark: '#D0021B',
        contrast: '#FFFFFF',
      },
      warning: {
        main: '#FF9913',
        light: '#FF9913',
        dark: '#FF9913',
        contrast: '#FFFFFF',
      },
      order: {
        main: '#D329A0',
        light: '#FF5ECF',
        dark: '#A11A79',
        contrast: '#FFFFFF',
      },
      update: {
        main: '#7E68C2',
        light: '#B39FF1',
        dark: '#5A4A8A',
        contrast: '#FFFFFF',
      },
      maintenance: {
        main: '#F3DB4C',
        light: '#FFEF90',
        dark: '#DEBE00',
        contrast: '#FFFFFF',
      },
      approve: {
        main: '#00B000',
        light: '#00B000',
        dark: '#00B000',
        contrast: '#FFFFFF',
      },
      reject: {
        main: '#FF233E',
        light: '#FF233E',
        dark: '#FF233E',
        contrast: '#FFFFFF',
      },
      review: {
        main: '#FFD700',
        light: '#FFD700',
        dark: '#FFD700',
        contrast: '#191919',
      },
      messageDialog: {
        main: '#323946',
        light: '#384054',
        dark: '#1A212E',
        contrast: '#FFFFFF',
      },
      dashboard: {
        purple: '#8452ED',
        green: '#67DE92',
        white: '#FFFFFF',
      },
      milestone: {
        brief: '#F9D6D2',
        modeling: '#ACE9F7',
        studioReview: '#9DC3D9',
        customerReview: '#E7CFB8',
        finalisation: '#DAECC7',
        glbCreation: '#CFD2DB',
        updateProductThumbnail: '#DDC5D6',
        uploadSTFiles: '#B2A4FF',
        editST: '#FFB4B4',
        renderLDPlain: '#FFDEB4',
        renderLDPlainLayers: '#6096B4',
        renderLPLayers: '#BDCDD6',
        QASTInfinite: '#ECA869',
        setSTTesting: '#B08BBB',
        exitTestingFlow: '#73A9AD',
        replaceDefaultProducts: '#CCD5AE',
        activateST: '#FAEDCD',
        importVideo: '#FF958C',
        importSilo: '#E8C7DE',
        createACloseUp: '#FFC700',
        pdpPackageReviewByCustomer: '#EA7B72',
        createProductFocusWithAI: '#6A994E',
      },
      deadlineDistribution: {
        modeler: '#64CCC5',
        qcCheck: '#6096B4',
        rework: '#FF958C',
        studioReview: '#E8C7DE',
      },
      role: {
        [USER_ROLES.ACCOUNT_MANAGER]: '#8045A6',
        [USER_ROLES.ADMIN]: '#8564B8',
        [USER_ROLES.API_STANDARD_USER]: '#3F3957',
        [USER_ROLES.CLUSTER_MANAGER_MODELING]: '#2F7A90',
        [USER_ROLES.DISPLAY]: '#2C8A78',
        [USER_ROLES.ORGANIZATIONS_ADMINISTRATOR]: '#88C336',
        [USER_ROLES.OWNER]: '#D4AE4A',
        [USER_ROLES.PRODUCTION_MANAGER]: '#DF5E00',
        [USER_ROLES.PROJECT_MANAGER]: '#C0563C',
        [USER_ROLES.SUPERADMIN]: '#BD5261',
        [USER_ROLES.SUPERUSER]: '#D00F6D',
        [USER_ROLES.TESTER]: '#F969C5',
      },
      certificateType: {
        '3DModeler': '#35E15C',
        '3DModelerChecker': '#01DB8D',
        clusterManager: '#02D5E1',
        imageEditor: '#B08BBB',
        default: '#015D8F',
      },
      batch: {
        main: '#D329A0',
        light: '#FF5ECF',
        dark: '#A11A79',
        contrast: '#FFFFFF',
      },
    },
    font: {
      size: {
        xxs: 8,
        xs: 10,
        s: 12,
        default: 14,
        m: 18,
        l: 22,
        xl: 26,
        xxl: 32,
        xxxl: 40,
      },
      weight: {
        light: '200',
        regular: '400',
        mid: '500',
        bold: '600',
        bolder: '700',
      },
      family: {
        default: 'Poppins, Source Sans Pro, Helvetica, sans-serif',
      },
    },
  },
}

export const themeLight = {
  colors: {
    primary: {
      light: '#436AFF',
      main: '#436AFF',
      dark: '#436AFF',
      contrast: '#FFF',
    },
    secondary: {
      light: '#191919',
      lighter: '#323540',
      main: '#191919',
      dark: '#191919',
      contrast: '#FFF',
    },
    tertiary: {
      light: '#92B6FA',
      main: '#92B6FA',
      dark: '#92B6FA',
      contrast: '#FFF',
    },
    green: {
      main: '#59E6C8',
      light: '#59E6C8',
      dark: '#59E6C8',
      contrast: '#191919',
    },
    lightRed: {
      main: '#FF958C',
      light: '#FF958C',
      dark: '#FF958C',
      contrast: '#252525',
    },
    purple: {
      main: '#7A69BC',
      second: '#B08BBB',
      light: '#E8E2FF',
      lighter: '#E8C7DE33',
      dark: '#6859A0',
      contrast: '#252525',
    },
    darkGreen: {
      main: '#0080001A',
      contrast: '#008000',
    },
    darkPurple: {
      main: '#1E0E32',
      light: '#1E0E32',
      dark: '#120127',
      contrast: '#FFFFFF',
    },
    lightGray: {
      main: '#F2F2F2',
      light: '#F2F2F2',
      dark: '#F2F2F2',
      contrast: '#191919',
    },
    gray: {
      lighter: '#F9F9F9',
      light: '#F2F2F2',
      main: '#B1B1B1',
      second: '#979797',
      dark: '#565656',
      darker: '#363636',
      contrast: '#191919',
    },
    text: {
      main: '#191919',
      gray: '#B1B1B1',
      contrast: '#FFF',
    },
    white: {
      main: '#FFF',
      light: '#FFF',
      dark: '#FFF',
      contrast: '#191919',
    },
    darkBlue: {
      main: '#373944',
      light: '#373944',
      dark: '#171B32',
      darker: '#272A36',
      contrast: '#FFF',
    },
    transparent: {
      main: 'transparent',
      light: 'transparent',
      dark: 'transparent',
      contrast: '#191919',
    },
    background: {
      lighter: '#FFF',
      light: '#FFF',
      main: '#FFF',
      second: '#E5E5E5',
      dark: '#FFF',
      contrast: '#191919',
    },
    tag: TAG_COLORS_LIGHT,
    alert: {
      main: '#E81D1D',
      light: '#E81D1D',
      dark: '#E81D1D',
      contrast: '#FFFFFF',
    },
    warning: {
      main: '#FF9913',
      light: '#FF9913',
      dark: '#FF9913',
      contrast: '#FFFFFF',
    },
    order: {
      main: '#436AFF',
      light: '#436AFF',
      dark: '#436AFF',
      contrast: '#FFFFFF',
    },
    update: {
      main: '#7E68C2',
      light: '#B39FF1',
      dark: '#5A4A8A',
      contrast: '#FFFFFF',
    },
    maintenance: {
      main: '#F3DB4C',
      light: '#FFEF90',
      dark: '#DEBE00',
      contrast: '#FFFFFF',
    },
    approve: {
      main: '#008000',
      light: '#008000',
      dark: '#008000',
      contrast: '#FFFFFF',
    },
    reject: {
      main: '#FF233E',
      light: '#FF233E',
      dark: '#FF233E',
      contrast: '#FFFFFF',
    },
    review: {
      main: '#FFD700',
      light: '#FFD700',
      dark: '#FFD700',
      contrast: '#191919',
    },
    customerReview: {
      main: '#E7CFB8',
      light: '#E7CFB8',
      dark: '#E7CFB8',
      contrast: '#191919',
    },
    messageDialog: {
      light: '#272A36',
      main: '#272A36',
      dark: '#272A36',
      contrast: '#FFFFFF',
    },
    dashboard: {
      purple: '#8452ED',
      green: '#67DE92',
      white: '#565656',
    },
    milestone: {
      brief: '#F9D6D2',
      modeling: '#ACE9F7',
      studioReview: '#9DC3D9',
      customerReview: '#E7CFB8',
      finalisation: '#DAECC7',
      glbCreation: '#CFD2DB',
      updateProductThumbnail: '#DDC5D6',
      uploadSTFiles: '#B2A4FF',
      editST: '#FFB4B4',
      renderLDPlain: '#FFDEB4',
      renderLDPlainLayers: '#6096B4',
      renderLPLayers: '#BDCDD6',
      QASTInfinite: '#ECA869',
      setSTTesting: '#B08BBB',
      exitTestingFlow: '#73A9AD',
      replaceDefaultProducts: '#CCD5AE',
      activateST: '#FAEDCD',
      pdpNoop: '#B08BBB',
      automateGenerationContent: '#64CCC5',
      deliverPdpPackage: '#A0153E',
      importProductFocus: '#D6CC99',
      importVideo: '#FF958C',
      importWideAngle: '#B0D9B1',
      importSilo: '#E8C7DE',
      createACloseUp: '#FFC700',
      pdpPackageReviewByCustomer: '#E7CFB8',
      createProductFocusWithAI: '#6A994E',
      waitPrerequisites: '#C6A093',
    },
    deadlineDistribution: {
      modeler: '#64CCC5',
      qcCheck: '#6096B4',
      rework: '#FF958C',
      studioReview: '#E8C7DE',
    },
    role: {
      [USER_ROLES.ACCOUNT_MANAGER]: '#8045A6',
      [USER_ROLES.ADMIN]: '#8564B8',
      [USER_ROLES.API_STANDARD_USER]: '#3F3957',
      [USER_ROLES.CLUSTER_MANAGER_MODELING]: '#2F7A90',
      [USER_ROLES.DISPLAY]: '#2C8A78',
      [USER_ROLES.ORGANIZATIONS_ADMINISTRATOR]: '#88C336',
      [USER_ROLES.OWNER]: '#D4AE4A',
      [USER_ROLES.PRODUCTION_MANAGER]: '#DF5E00',
      [USER_ROLES.PROJECT_MANAGER]: '#C0563C',
      [USER_ROLES.SUPERADMIN]: '#BD5261',
      [USER_ROLES.SUPERUSER]: '#D00F6D',
      [USER_ROLES.TESTER]: '#F969C5',
    },
    certificateType: {
      '3DModeler': '#35E15C',
      '3DModelerChecker': '#01DB8D',
      clusterManager: '#02D5E1',
      imageEditor: '#B08BBB',
      default: '#015D8F',
    },
    batch: {
      main: '#436AFF',
      light: '#436AFF',
      dark: '#436AFF',
      contrast: '#FFFFFF',
    },
    vcp: {
      trayCompletion: '#FF958C',
      trayOrdering: '#FFD700',
      technicalSpecs: '#DDC5D6',
      extraVisualsPenalty: '#FF4141',
      complianceScoreTier1: '#FF1B0F',
      complianceScoreTier2: '#FF6F0F',
      complianceScoreTier3: '#F2CC23',
      complianceScoreTier4: '#C1E338',
      complianceScoreTier5: '#5BCA27',
      complianceScoreTier6: '#008000',
      pivotDataProprietary: '#D24BE6',
      pivotDataProprietaryBackground: '#D24BE61A',
    },
  },
  font: {
    size: {
      xxs: 7,
      xs: 10,
      s: 12,
      default: 14,
      m: 18,
      l: 22,
      xl: 26,
      xxl: 32,
      xxxl: 40,
    },
    weight: {
      light: '200',
      regular: '400',
      mid: '500',
      bold: '600',
      bolder: '700',
    },
    family: {
      default: 'Poppins, Source Sans Pro, Helvetica, sans-serif',
    },
  },
  modeHighlight: {
    colors: {
      primary: {
        main: '#436AFF',
        light: '#587BFF',
        dark: '#2750F0',
        contrast: '#FFFFFF',
      },
      secondary: {
        dark: '#191919',
        main: '#191919',
        light: '#323232',
        contrast: '#FFFFFF',
      },
      tertiary: {
        main: '#9AA7FF',
        light: '#BBC4FF',
        dark: '#8694FF',
        contrast: '#252525',
      },
      green: {
        main: '#59E6C8',
        light: '#59E6C8',
        dark: '#59E6C8',
        contrast: '#252525',
      },
      lightRed: {
        main: '#FF958C',
        light: '#FF958C',
        dark: '#FF958C',
        contrast: '#252525',
      },
      purple: {
        main: '#7A69BC',
        light: '#E8E2FF',
        dark: '#6859A0',
        contrast: '#252525',
      },
      lightGray: {
        main: '#F2F2F2',
        light: '#F2F2F2',
        dark: '#F2F2F2',
        contrast: '#191919',
      },
      gray: {
        darker: '#191919',
        dark: '#191919',
        main: '#252525',
        second: '#2C2C2C',
        light: '#323232',
        lighter: '#9D9D9D',
        contrast: '#FFFFFF',
      },
      text: {
        main: '#FFFFFF',
        gray: '#9D9D9D',
        contrast: '#191919',
      },
      white: {
        main: '#FFFFFF',
        light: '#FFFFFF',
        dark: '#FFFFFF',
        contrast: '#191919',
      },
      transparent: {
        main: 'transparent',
        light: 'transparent',
        dark: 'transparent',
        contrast: '#FFFFFF',
      },
      background: {
        dark: '#191919',
        main: '#252525',
        second: '#2C2C2C',
        light: '#323232',
        lighter: '#9D9D9D',
        contrast: '#FFFFFF',
      },
      tag: TAG_COLORS_LIGHT,
      alert: {
        main: '#FF4141',
        light: '#FF6464',
        dark: '#D0021B',
        contrast: '#FFFFFF',
      },
      warning: {
        main: '#FF9913',
        light: '#FF9913',
        dark: '#FF9913',
        contrast: '#FFFFFF',
      },
      order: {
        main: '#D329A0',
        light: '#FF5ECF',
        dark: '#A11A79',
        contrast: '#FFFFFF',
      },
      update: {
        main: '#7E68C2',
        light: '#B39FF1',
        dark: '#5A4A8A',
        contrast: '#FFFFFF',
      },
      maintenance: {
        main: '#F3DB4C',
        light: '#FFEF90',
        dark: '#DEBE00',
        contrast: '#FFFFFF',
      },
      approve: {
        main: '#00B000',
        light: '#00B000',
        dark: '#00B000',
        contrast: '#FFFFFF',
      },
      reject: {
        main: '#FF233E',
        light: '#FF233E',
        dark: '#FF233E',
        contrast: '#FFFFFF',
      },
      review: {
        main: '#FFD700',
        light: '#FFD700',
        dark: '#FFD700',
        contrast: '#191919',
      },
      messageDialog: {
        light: '#272A36',
        main: '#272A36',
        dark: '#272A36',
        contrast: '#FFFFFF',
      },
      dashboard: {
        purple: '#8452ED',
        green: '#67DE92',
        white: '#FFFFFF',
      },
      milestone: {
        brief: '#F9D6D2',
        modeling: '#ACE9F7',
        studioReview: '#9DC3D9',
        customerReview: '#E7CFB8',
        finalisation: '#DAECC7',
        glbCreation: '#CFD2DB',
        updateProductThumbnail: '#DDC5D6',
        uploadSTFiles: '#B2A4FF',
        editST: '#FFB4B4',
        renderLDPlain: '#FFDEB4',
        renderLDPlainLayers: '#6096B4',
        renderLPLayers: '#BDCDD6',
        QASTInfinite: '#ECA869',
        setSTTesting: '#B08BBB',
        exitTestingFlow: '#73A9AD',
        replaceDefaultProducts: '#CCD5AE',
        activateST: '#FAEDCD',
        importVideo: '#FF958C',
        importSilo: '#E8C7DE',
        createACloseUp: '#FFC700',
        pdpPackageReviewByCustomer: '#EA7B72',
        createProductFocusWithAI: '#6A994E',
      },
      deadlineDistribution: {
        modeler: '#64CCC5',
        qcCheck: '#6096B4',
        rework: '#FF958C',
        studioReview: '#E8C7DE',
      },
      role: {
        [USER_ROLES.ACCOUNT_MANAGER]: '#8045A6',
        [USER_ROLES.ADMIN]: '#8564B8',
        [USER_ROLES.API_STANDARD_USER]: '#3F3957',
        [USER_ROLES.CLUSTER_MANAGER_MODELING]: '#2F7A90',
        [USER_ROLES.DISPLAY]: '#2C8A78',
        [USER_ROLES.ORGANIZATIONS_ADMINISTRATOR]: '#88C336',
        [USER_ROLES.OWNER]: '#D4AE4A',
        [USER_ROLES.PRODUCTION_MANAGER]: '#DF5E00',
        [USER_ROLES.PROJECT_MANAGER]: '#C0563C',
        [USER_ROLES.SUPERADMIN]: '#BD5261',
        [USER_ROLES.SUPERUSER]: '#D00F6D',
        [USER_ROLES.TESTER]: '#F969C5',
      },
      certificateType: {
        '3DModeler': '#35E15C',
        '3DModelerChecker': '#01DB8D',
        clusterManager: '#02D5E1',
        imageEditor: '#B08BBB',
        default: '#015D8F',
      },
      batch: {
        main: '#D329A0',
        light: '#FF5ECF',
        dark: '#A11A79',
        contrast: '#FFFFFF',
      },
    },
    font: {
      size: {
        xxs: 8,
        xs: 10,
        s: 12,
        default: 14,
        m: 18,
        l: 22,
        xl: 26,
        xxl: 32,
        xxxl: 40,
      },
      weight: {
        light: '200',
        regular: '400',
        mid: '500',
        bold: '600',
        bolder: '700',
      },
      family: {
        default: 'Poppins, Source Sans Pro, Helvetica, sans-serif',
      },
    },
  },
}

export function getTheme(darkMode = false) {
  if (darkMode) {
    return themeDark
  }

  return themeLight
}
